import React, { useEffect, useState } from 'react'
import { Button } from './Buttons'

export function NavTabs(props) {
  const {
    size = 'auto', // or "100px"
    direction = 'column', // row | column
    children,
    variant = 'info',
  } = props

  const [selectedName, setSelectedName] = useState('')

  useEffect(() => {
    React.Children.map(children, (child, i) => {
      if (i === 0) setSelectedName(child.props.name)
      return null
    })
  }, [children])

  const commonStyles = {
    wrap: {
      display: 'flex',
      flexDirection: direction,
      marginLeft: 15,
      marginRight: 15,
      // backgroundColor: "green"
    },
    navTabs: {
      width: direction === 'column' ? '100%' : '30%',
      // padding: 10,
      display: 'flex',
      flexDirection: direction === 'column' ? 'row' : 'column',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    btn: {
      width: size,
      marginRight: 5,
    },
    child: {
      flex: 1,
    },
  }

  return (
    <div style={commonStyles.wrap}>
      <div style={commonStyles.navTabs}>
        {React.Children.map(children, (child, i) => {
          let btnVariant = 'outline-' + variant
          if (child.props.name === selectedName) {
            btnVariant = variant
          }
          return (
            <Button
              style={commonStyles.btn}
              key={i}
              title={child.props.name}
              variant={btnVariant}
              onClick={() => setSelectedName(child.props.name)}
            />
          )
        })}
      </div>

      {React.Children.map(children, (child, i) => {
        if (child.props.name === selectedName) {
          return React.cloneElement(child, { index: i })
        } else {
          return null
        }
      })}
    </div>
  )
}
